import React from 'react';
const Billing: React.FC = () => (
  <div className='text-2xl font-bold'>Billing (Stub Page)</div>
);
export default Billing;
